import MenuItem from "@mui/material/MenuItem";
import type { MenuItemProps } from "@mui/material/MenuItem";
import type { JSX } from "react";

/**
 * Пункт меню как кнопка дизайн-системы: MUI держит его в roving-фокусе меню и
 * сам поднимает нажатие с клавиатуры, а имя примитива прямо говорит, что это
 * действие, а не строка списка.
 */
export function MenuActionButton(props: MenuItemProps): JSX.Element {
  return <MenuItem {...props} />;
}
